<template>
  <div class="fillcontain">
    <div class="table_container">
      <div class="block">
        <el-date-picker
          v-model="value2"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-select
          style="margin-left: 20px"
          v-model="courseCoach"
          placeholder="请选择教练"
        >
          <el-option
            v-for="item in coachList"
            :key="item.coachName"
            :label="item.label"
            :value="item.coachName"
          ></el-option>
        </el-select>
        <el-select
          style="margin-left: 20px"
          v-model="classType"
          placeholder="请选择班级类型"
        >
          <el-option
            v-for="item in typeList"
            :key="item.value"
            :label="item.text"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button
          :disabled="buttonStatus"
          v-show="ROLE == 1"
          style="margin-left: 50px"
          type="primary"
          @click="onSubmit()"
          >{{ buttonText }}</el-button
        >
        <el-button
          :disabled="buttonStatus1"
          v-show="ROLE == 1"
          style="margin-left: 50px"
          type="success"
          @click="onSubmit1()"
          >{{ buttonText1 }}</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { excel, memberCoursePackageExcel } from "@/api/course";
import { getCoachLists } from "@/api/coach";
import { getAllClassTypes } from "@/api/courseType";
import { getToken } from "@/utils/auth";
import { addOperationRecord } from "@/api/operationrecord";

export default {
  data() {
    return {
      form: {
        beginDate: "",
        endDate: "",
      },
      ROLE: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近两周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 2 * 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3 * 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value2: "",
      elink: document.createElement("a"),
      coachList: [],
      typeList: [],
      courseCoach: "不选择教练",
      classType: "不选择课程类型",
    };
  },
  components: {},
  computed: {
    ...mapGetters([
      "buttonStatus",
      "buttonText",
      "buttonStatus1",
      "buttonText1",
    ]),
  },
  mounted() {
    this.getCoachList();
    this.getCourseType();
  },
  created() {
    this.ROLE = getToken("ROLE");
    // console.log(this.ROLE);
  },
  methods: {
    //获取教练列表
    getCoachList() {
      const para = {
        page: 1,
        limit: 100,
        coachName: "",
      };
      getCoachLists(para).then((res) => {
        console.log(res);
        let all = {
          coachName: "不选择教练",
        };
        this.coachList = res.data.data.coachData;
        this.coachList.push(all);
        console.log(this.coachList);
      });
    },
    getCourseType() {
      var para = {
        page: 1,
        limit: 100,
      };
      getAllClassTypes(para).then((res) => {
        console.log(res);
        let all = {
          text: "不选择班级类型",
          value: "不选择班级类型",
        };
        this.typeList = res.data.data.courseTypeDataList;
        console.log(this.typeList);
        this.typeList.push(all);
      });
    },
    onSubmit1() {
      let para = {};
      this.$store.commit("SET_BUTTON_STATUS1", true);
      this.$store.commit("SET_BUTTON_TEXT1", "正在生成excel，请稍等");
      memberCoursePackageExcel(para).then((res) => {
        const content = res;
        const blob = new Blob([res.data], {
          type: " application/vnd.ms-excel",
        });
        const a = document.createElement("a");
        // 生成文件路径
        let href = window.URL.createObjectURL(blob);
        a.href = href;
        let _fileName = decodeURIComponent(
          res.headers["content-disposition"].split(";")[1].split("=")[1]
        );
        // 文件名中有中文 则对文件名进行转码
        a.download = _fileName;
        // 利用a标签做下载
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(href);
        this.$store.commit("SET_BUTTON_STATUS1", false);
        this.$store.commit("SET_BUTTON_TEXT1", "点击生成excel");
        const para = {
          userName: getToken("USERNAME"),
          content: "点击生成会员课时情况报表操作",
        };
        addOperationRecord(para).then((res) => {
          console.log(res);
        });
      });
    },
    onSubmit() {
      console.log(this.value2 === "");
      if (this.value2 === "") {
        this.$message({
          message: "日期不能为空",
          type: "warning",
        });
      } else {
        this.$store.commit("SET_BUTTON_STATUS", true);
        this.$store.commit("SET_BUTTON_TEXT", "正在生成excel，请稍等");
        const para = {
          beginDateStr: this.value2[0],
          endDateStr: this.value2[1],
          courseCoach: this.courseCoach,
          classType: this.classType,
        };
        excel(para).then((res) => {
          console.log(res);
          if (res.status == 202) {
            this.$message({
              message: "该日期段内没有课程",
              type: "warning",
            });
          } else if (res.status == 201) {
            this.$message({
              message: "日期不能为空",
              type: "warning",
            });
          } else {
            const content = res;
            const blob = new Blob([res.data], {
              type: " application/vnd.ms-excel",
            });
            const a = document.createElement("a");
            // 生成文件路径
            let href = window.URL.createObjectURL(blob);
            a.href = href;
            let _fileName = decodeURIComponent(
              res.headers["content-disposition"].split(";")[1].split("=")[1]
            );
            // 文件名中有中文 则对文件名进行转码
            a.download = _fileName;
            // 利用a标签做下载
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(href);
            this.$store.commit("SET_BUTTON_STATUS", false);
            this.$store.commit("SET_BUTTON_TEXT", "点击生成excel");
            const para = {
              userName: getToken("USERNAME"),
              content: "点击生成课程情况报表操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
}
.el-row {
  margin-bottom: 50px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.el-col-border {
  border: 1px solid #ebebeb;
  margin: 5px 5px;
}
</style>


